// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortControl_wrapper__1qCHp","control":"SortControl_control__DZf16","disabled":"SortControl_disabled__BZQPO"};